import { Sparkles } from "lucide-react";
import { SuggestionChips } from "./SuggestionChips";
import type { SuggestionChip } from "../../lib/pro-chat-suggestions";

// EMPTY dock state (scenario 677, plan 188 task 802): centered spark + "Ask
// Sill" + description + a column of per-page seeded suggestion chips.
export function EmptyState({
  chips,
  onSelectChip,
}: {
  chips: SuggestionChip[];
  onSelectChip: (prompt: string) => void;
}) {
  return (
    <div
      data-testid="copilot-empty-state"
      className="flex flex-1 flex-col items-center justify-center gap-4 px-4 py-8 text-center"
    >
      <span className="inline-flex size-10 items-center justify-center rounded-full bg-primary-soft text-primary">
        <Sparkles size={18} aria-hidden />
      </span>
      <div>
        <p className="text-sm font-semibold text-fg">Ask Sill</p>
        <p className="mt-1 text-xs text-fg-muted">
          Draft messages, campaigns, and invites — Sill never sends without
          your approval.
        </p>
      </div>
      <SuggestionChips chips={chips} onSelect={onSelectChip} />
    </div>
  );
}
